import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class UsermanagementService {
  constructor(private http: HttpClient) { }

  getUsers(pageNo: number, text: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/UserM/getDoctors?pageNo='+pageNo+'&text='+text);
  }

  blockActiveUser(id: string) {
    console.log('tetsts');
     return this.http.post(globalAdd.Paneladdress + 'api/HA/UserM/blockActiveUser', { id: id });
  }


  updateDeviceNameOfUser(newName, eaHospId) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/UserM/UpdateDeviceNameOfUser', { newName: newName, eaHospId: eaHospId });
  }



}
